import React from "react";
interface IChatIconSvg {
  height?: string | number;
  width?: string | number;
}
const ChatIconSvg: React.FC<IChatIconSvg> = (props: IChatIconSvg) => {
  const { height, width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "16"}
      height={height ? height : "16"}
      fill="currentColor"
      className="bi bi-chat-fill"
      viewBox="0 0 16 16"
    >
      <path d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9 9 0 0 0 8 15" />
    </svg>
  );
};

export default ChatIconSvg;
